import { combineReducers } from 'redux';
import { SELECT_TEMPLATE, LOAD_TEMPLATES } from './actions';

const init = {
  templates: []
}

export const tempReducer = (state={}, { type, payload }) => {
  switch(type) {
    case SELECT_TEMPLATE:
      return { ...state, ...payload }
    default:
      return state;
  }
}

export const allTemplates = (state=init.templates, { type, payload }) => {
  switch(type) {
    case LOAD_TEMPLATES:
      return { ...state, templates: payload }
    default:
      return state;
  }
}

const reducers = combineReducers({
  template: tempReducer,
  templates: allTemplates
});

export default reducers;